import { CSSProperties } from 'react';
import styled, { css } from 'styled-components';
import { spacingCss, SpacingCssProps } from '../Spacing/Spacing.styles';

export const StyledLink = styled.a.attrs<SpacingCssProps>(
  ({ theme, mbValue, mlValue, mtValue, mrValue }) => ({
    mbValue: mbValue || theme.spacing.m,
    mtValue: mtValue || theme.spacing.m,
    mrValue: mrValue || theme.spacing.m,
    mlValue: mlValue || theme.spacing.m,
  })
)<Pick<CSSProperties, 'display'>>(
  ({ theme, display = 'flex' }) => css`
    font-weight: 500;
    display: ${display};
    align-items: center;
    color: ${theme.color.dark};
    transition: ${theme.transition};
    text-decoration: underline;
    text-underline-offset: 2px;

    svg {
      height: 24px;
      width: 24px;
      margin: 0 4px;
      transition: fill 0.4s;
      fill: ${theme.color.dark};
    }

    &:hover {
      color: ${theme.color.greyDark};

      svg {
        fill: ${theme.color.greyDark};
      }
    }

    &:focus,
    &:active {
      color: ${theme.color.emeraldDark};
      border-color: ${theme.color.emeraldDark};

      svg {
        fill: ${theme.color.emeraldDark};
      }
    }

    &.disabled,
    &[disabled] {
      color: ${theme.color.grey};

      svg {
        fill: ${theme.color.grey};
      }
    }

    ${spacingCss}
  `
);
